import { jsx as _jsx } from "react/jsx-runtime";
import SettingSection from "../SettingSection";
const PromptLibraryTab = () => {
    return (_jsx(SettingSection, { title: "Prompt Library", children: _jsx("div", { className: "p-5 text-center text-gray-600", children: "Prompt library settings coming soon..." }) }));
};
export default PromptLibraryTab;
